import { Component, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { AuthService } from 'src/app/auth/auth.service';
import { ToastService } from 'src/app/shared/services/toast.service';
import { State } from 'src/app/store/state';
import { IMToolService } from '../services/im-tool.service';
import { MatDialog } from '@angular/material/dialog';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { Subject, takeUntil } from 'rxjs';
import { LaunchDarklyService } from 'src/app/shared/services/launch-darkly.service';

@Component({
    selector: 'app-im-tool',
    templateUrl: './im-tool.component.html',
    styleUrls: ['./im-tool.component.scss'],
    animations: [
        trigger('detailExpand', [
            state('collapsed', style({ height: '0px', minHeight: '0' })),
            state('expanded', style({ height: '*' })),
            transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
        ]),
    ],
    standalone: false
})
export class IMToolComponent implements OnInit, OnDestroy {
  isMultiMaxDeviceEnabled = false;
  private readonly destroy$ = new Subject<void>();

  constructor(
    public imToolService: IMToolService,
    public auth: AuthService,
    public toastService: ToastService,
    public store: Store<State>,
    public dialog: MatDialog,
    private launchDarklyService: LaunchDarklyService,
  ) { }

  ngOnInit(): void {
    const flagKey = 'multimax-device-feature';
    this.isMultiMaxDeviceEnabled = this.launchDarklyService.getBooleanFlag(flagKey, false);

    this.launchDarklyService.flagChange
      .pipe(takeUntil(this.destroy$))
      .subscribe((flags: Record<string, unknown>) => {
        this.isMultiMaxDeviceEnabled = Boolean(flags[flagKey] ?? false);
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
